import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/Loupe.png'


const _withScopeId = n => (_pushScopeId("data-v-65370e57"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = { class: "col-lg-6 col-sm-12 p-5" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { "data-aos": "fade-up" }, "FIND SOMEONE TO TAKE UP THE TORCH", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "mb-5",
  "data-aos": "fade-up"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "TumiOrange" }, "ProjectLifeKey"),
  /*#__PURE__*/_createTextVNode(" is a service that is constantly evolving. The next feature we would like to add is the ability for users to find others who could potentially take over their projects. This feature would include a search function that allows users to filter potential candidates by job, skill, location, and other relevant criteria, enabling them to find the most suitable person to continue their project. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("We believe that this feature would greatly enhance our service. What do you think? ")
], -1))
const _hoisted_6 = {
  key: 0,
  "data-aos": "fade-up"
}
const _hoisted_7 = {
  key: 1,
  class: "TumiThanks",
  "data-aos": "fade-up"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 col-sm-12 text-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "img-fluid mt-3",
    "data-aos": "fade-up"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "bg",
    style: _normalizeStyle({'background-image' : 'url('+ require('@/assets/search.jpg') +')'})
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          (!_ctx.deactivate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("button", {
                  class: "btn btn-info float-end",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.No && _ctx.No(...args)))
                }, "No thanks"),
                _createElementVNode("button", {
                  class: "btn btn-info float-start",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.Yes && _ctx.Yes(...args)))
                }, "I love it")
              ]))
            : _createCommentVNode("", true),
          (_ctx.deactivate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Thanks for your vote. Feedback from our users is super important to us and greatly appreciated. "))
            : _createCommentVNode("", true)
        ]),
        _hoisted_8
      ])
    ])
  ], 4))
}